import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 3,
  class: "performance-editor"
}

import type { PerformanceClip } from "../../types/DialogueNode";
import ClipComponentsEditor from "./ClipComponentsEditor.vue";
import PublicEventClipEditor from "./PublicEventClipEditor.vue";
import CustomClipEditor from "./CustomClipEditor.vue";
import CameraClipEditor from "./CameraClipEditor.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'PerformanceClipEditor',
  props: {
    clip: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (__props.clip.type === 'Camera')
    ? (_openBlock(), _createBlock(CameraClipEditor, {
        key: 0,
        clip: __props.clip
      }, null, 8, ["clip"]))
    : (__props.clip.type === 'Custom')
      ? (_openBlock(), _createBlock(CustomClipEditor, {
          key: 1,
          clip: __props.clip
        }, null, 8, ["clip"]))
      : (__props.clip.type === 'PublicEvent')
        ? (_openBlock(), _createBlock(PublicEventClipEditor, {
            key: 2,
            clip: __props.clip
          }, null, 8, ["clip"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("label", null, [
              _cache[1] || (_cache[1] = _createTextVNode("Clip 名称", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.clip.name) = $event))
              }, null, 512), [
                [_vModelText, __props.clip.name]
              ])
            ]),
            _createVNode(ClipComponentsEditor, { clip: __props.clip }, null, 8, ["clip"])
          ]))
}
}

})